export const CustomerClaimStatusEnum = Object.freeze({
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
});
